/**
 * Subtle Circles reveal — staggered fade-up for .is-style-subtle-circles cards.
 *
 * The `data-reveal="pending"` attribute is set here in JS (not in CSS), so cards
 * are always fully visible in the block editor and in no-JS environments.
 * Siblings in the same parent are staggered by 80 ms each.
 */
export function initSubtleCirclesReveal() {
	// Honour reduced-motion preference at the JS level too.
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) return;

	const cards = document.querySelectorAll( '.is-style-subtle-circles' );
	if ( ! cards.length || ! ( 'IntersectionObserver' in window ) ) return;

	// Mark each card pending and compute stagger delay relative to its siblings.
	cards.forEach( ( card ) => {
		const parent = card.parentElement;
		const siblings = parent
			? [ ...parent.children ].filter( ( c ) =>
					c.classList.contains( 'is-style-subtle-circles' )
			  )
			: [ card ];
		const idx = siblings.indexOf( card );
		card.setAttribute( 'data-reveal', 'pending' );
		card.style.transitionDelay = idx * 0.08 + 's';
	} );

	const io = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( ! entry.isIntersecting ) return;
				entry.target.removeAttribute( 'data-reveal' );
				// Clear the stagger delay after the reveal completes so hover
				// transitions don't inherit it and feel sluggish.
				setTimeout( () => {
					entry.target.style.transitionDelay = '';
				}, 800 );
				io.unobserve( entry.target );
			} );
		},
		{ threshold: 0.1 }
	);

	cards.forEach( ( card ) => io.observe( card ) );
}
